export default "__VITE_ASSET__$ccdN4OE__"